import http, { handleHttpError, handleHttpResponse } from '../../services/http'
import { HTTPResponse, IPaginationResponse } from '../../services/http/http.types'
import {
  CheckResultArtefact,
  InspectionProjectTypeOverview,
  IGetInspectorCheckResultsParams,
  InspectorCheckResult,
} from './inspection.types'

const getProjectTypesInspectionOverview = async (): Promise<HTTPResponse<InspectionProjectTypeOverview[]>> => {
  return http.get(`/nsi/v1/inspector/project-types`).then(handleHttpResponse).catch(handleHttpError)
}

/**
 * Получить работы для проверки инспектором
 */
const getInspectorCheckResults = async (
  params: IGetInspectorCheckResultsParams
): Promise<HTTPResponse<IPaginationResponse<InspectorCheckResult>>> => {
  return http
    .get('/nsi/v1/inspector/check-results', { params })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const getCheckResult = async (id: string): Promise<HTTPResponse<InspectorCheckResult>> => {
  return http.get(`/nsi/v1/inspector/check-results/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

/**
 * Артефакты (ответы команды) по результату проверки
 * GET /nsi/v1/project-checkpoints/check-results/:id/artefacts
 */
const getCheckResultArtefacts = async (
  id: string
): Promise<HTTPResponse<{ items: CheckResultArtefact[] } | CheckResultArtefact[]>> => {
  return http
    .get(`/nsi/v1/project-checkpoints/check-results/${id}/artefacts`)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

/**
 * Назначить инспектора на результат проверки
 */
const assignInspector = async (
  checkResultId: string,
  inspectorId: number
): Promise<HTTPResponse<InspectorCheckResult>> => {
  return http
    .patch(`/nsi/v1/inspector/check-results/${checkResultId}/inspector`, { inspectorId })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

export interface ISubmitPassCheckResultBody {
  id: number
  checkpointId: string
  teamId: number
  grade: number
  comment: string
  criteriaResults: Array<{ projectCheckpointCriteriaId: string; grade: number }>
}

/**
 * Отправить оценку (результат проверки)
 * POST /nsi/v1/projects/:id/checkpoints/:checkpointId/pass-check-results
 */
const submitPassCheckResult = async (
  projectId: number,
  checkpointId: string,
  body: Omit<ISubmitPassCheckResultBody, 'id' | 'checkpointId'>
): Promise<HTTPResponse<InspectorCheckResult>> => {
  return http
    .post(`/nsi/v1/projects/${projectId}/checkpoints/${checkpointId}/pass-check-results`, {
      id: projectId,
      checkpointId,
      ...body,
    })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const inspectionApi = {
  getProjectTypesInspectionOverview,
  getInspectorCheckResults,
  getCheckResult,
  getCheckResultArtefacts,
  assignInspector,
  submitPassCheckResult,
}
export default inspectionApi
